export default class rubricasServices{

    constructor(resource){
        this._resource = resource('{complementoRota}/{texto}');
    }
    
    busca(complementoRota, texto){
        return this._resource
                .get({complementoRota,texto}, {
                    headers:{
                        "Access-Control-Allow-Origin:" : "*"
                    }
                })
                .then(res => res.json())
                .catch(err => console.error(err));
    }
    lista(complementoRota){
        return this._resource
            .get({complementoRota}, {
                headers:{
                    "Access-Control-Allow-Origin:" : "*"
                }
            })
            .then(res => res.json())
            .catch(err => console.error(err));
    }

}


// WEBPACK FOOTER //
// ./src/services/rubricasServices.js